import React from "react";

const GlassPinboard = ({ children, className = "" }) => {
  return (
    <div className={`relative ${className}`}>
      {/* Glassmorphic Pinboard */}
      <div
        style={{
          width: 661,
          height: 526,
          borderRadius: 20,
          background: "linear-gradient(142.13deg, rgba(255, 255, 255, 0.116) 1.8%, rgba(255, 255, 255, 0.132) 99.75%)",
          border: "10px solid transparent",
          borderImage: "linear-gradient(143.48deg, rgba(255, 255, 255, 0.43) 9.15%, rgba(227, 227, 227, 0.41) 112.98%) 1",
          backdropFilter: "blur(130px)",
          boxShadow: "0px 4px 15.8px 0px rgba(0, 0, 0, 0.25)",
          position: "relative",
        }}
      >
        {/* Corner Nuts */}
        {/* Top-left nut */}
        <div
          style={{
            position: "absolute",
            top: 20,
            left: 20,
            width: 20.3,
            height: 20,
          }}
        >
          <Nut />
        </div>

        {/* Top-right nut */}
        <div
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            width: 20.3,
            height: 20,
          }}
        >
          <Nut />
        </div>

        {/* Bottom-left nut */}
        <div
          style={{
            position: "absolute",
            bottom: 20,
            left: 20,
            width: 20.3,
            height: 20,
          }}
        >
          <Nut />
        </div>

        {/* Bottom-right nut */}
        <div
          style={{
            position: "absolute",
            bottom: 20,
            right: 20,
            width: 20.3,
            height: 20,
          }}
        >
          <Nut />
        </div>

        {/* Content area for sticky notes */}
        <div className="relative w-full h-full">
          {children}
        </div>
      </div>
    </div>
  );
};

// Nut Component
const Nut = () => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
      }}
    >
      {/* Outer circle with metallic gradient */}
      <div
        style={{
          position: "absolute",
          width: 12.075,
          height: 12.073,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "50%",
          background: "radial-gradient(circle at 30% 30%, #FFFFFF 0%, #F3F3F3 10%, #D3D3D3 30%, #A0A0A0 50%, #7D7D7D 60%, #373737 70%, #1D1D1D 80%, #AAAAAA 90%, #C8C8C8 100%)",
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.3)",
        }}
      >
        {/* Diagonal groove line */}
        <div
          style={{
            position: "absolute",
            width: 11.43,
            height: 8.095,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%) rotate(-45deg)",
            background: "linear-gradient(139.8deg, #050505 38.05%, #0F0F0F 40.28%, #191919 44.74%, #1D1D1D 51.43%)",
            borderRadius: 2,
            opacity: 0.6,
          }}
        />
      </div>
    </div>
  );
};

export default GlassPinboard;
